export default __webpack_public_path__ + "static/media/hand_like.b3f45ab4.png";